export class CreateSiteInfoApiClientRequest {
    siteInfoApiBaseUrl: string;
    secret: string;
    clientId: string;
    clientName: string;
    siteInfoCompanyId: string;
}
